import type { MessagingChannelsCopy } from './types';

export const DE: MessagingChannelsCopy = {
  title: 'Messaging',
  description:
    'Sprich mit IMAI aus den Chat-Apps, die du schon nutzt. Einmal verbinden, dann schreibst du IMAI direkt dort.',
  privacy:
    'Nachrichten aus deinen verbundenen Konten laufen in diesem Workspace unter deinem Namen und verbrauchen deine Credits.',
  loading: 'Messaging-Kanäle werden geladen',
  unavailable: 'Noch nicht verfügbar',
  unavailableNote: '{channel} ist für IMAI noch nicht eingerichtet.',
  connectedBadge: 'Verbunden',
  cancel: 'Abbrechen',

  phoneTitle: 'Telefonnummer',
  phoneNote: 'Verbinde WhatsApp oder iMessage mit deiner Telefonnummer.',
  phoneUnavailableNote: 'SMS an IMAI ist noch nicht eingerichtet.',
  addNumber: 'Nummer hinzufügen',
  countryLabel: 'Ländervorwahl',
  countrySearch: 'Land oder Vorwahl suchen…',
  countryEmpty: 'Keine Länder gefunden.',
  numberLabel: 'Telefonnummer',
  numberPlaceholder: 'Telefonnummer',
  numberHint: 'Land nicht in der Liste? Gib die vollständige Nummer mit + ein.',
  continueActivation: 'Weiter',
  editNumber: 'Nummer ändern',
  activateQr: 'Scannen und senden, um dich zu verbinden.',
  activateTitle: 'Schick eine Nachricht über WhatsApp',
  activateHint:
    'Tipp auf den Button und schick die vorausgefüllte Nachricht ab.',
  activateSentFrom: 'Schick sie von {number}.',
  activateButton: '{channel} öffnen',
  activateManual: 'Oder schick {message} über WhatsApp an {number}.',
  activateWaiting: 'Warte auf deine Nachricht. Läuft ab in {time}.',
  startAgain: 'Neu starten',
  verifiedBadge: 'Bestätigt',
  verifiedOn: 'Bestätigt am {date}',
  change: 'Ändern',
  changeAria: 'Telefonnummer {number} ändern',
  remove: 'Entfernen',
  removeAria: 'Telefonnummer {number} entfernen',
  messageImai: 'IMAI schreiben',
  messageImaiAria: 'IMAI über {channel} schreiben',
  removeTitle: '{number} entfernen?',
  removeDescription:
    'IMAI antwortet dieser Nummer dann nicht mehr über iMessage und WhatsApp. Du kannst sie jederzeit wieder hinzufügen.',
  removeError: 'Die Nummer konnte nicht entfernt werden. Versuch es erneut.',

  errorInvalidNumber: 'Gib eine gültige Telefonnummer mit Vorwahl ein.',
  errorNumberTaken:
    'Diese Nummer wird schon von einem anderen IMAI-Konto genutzt.',
  errorRateLimited:
    'Zu viele Versuche. Warte etwas und versuch es dann erneut.',
  errorChannelUnavailable:
    'Diese Option ist gerade nicht verfügbar. Wähl die andere.',
  errorSendFailed:
    'Die Bestätigung konnte nicht gestartet werden. Versuch es erneut.',
  errorActivationExpired: 'Diese Aktivierung ist abgelaufen. Starte neu.',

  noteSlack: 'Schreib IMAI aus deinem Slack-Workspace.',
  noteTeams: 'Schreib IMAI über Microsoft Teams.',
  noteTelegram: 'Chatte mit dem IMAI-Bot auf Telegram.',
  connect: 'Verbinden',
  connectAria: '{channel} verbinden',
  connectError:
    'Verbindung mit {channel} konnte nicht gestartet werden. Versuch es erneut.',
  connectedOn: 'Verbunden am {date}',
  accountFallback: 'Dein {channel}-Konto',
  installSlack: 'IMAI zu deinem Workspace hinzufügen',
  installTeams: 'IMAI zu Teams hinzufügen',
  openTelegram: 'In Telegram öffnen',
  disconnect: 'Trennen',
  disconnectAria: '{account} von {channel} trennen',
  disconnectError: '{channel} konnte nicht getrennt werden. Versuch es erneut.',
  disconnectTitle: '{channel} trennen?',
  disconnectDescription:
    'Nachrichten von {account} erreichen IMAI dann nicht mehr. Du kannst das Konto jederzeit wieder verbinden.',

  toastConnected: '{channel} verbunden',
  toastConnectedGeneric: 'Konto verbunden',
  toastErrorExpired: 'Die Anmeldung hat zu lange gedauert. Versuch es erneut.',
  toastErrorInvalidState:
    'Dieser Anmeldelink ist nicht mehr gültig. Versuch es erneut.',
  toastErrorAccountTaken:
    'Dieses Konto ist schon mit einem anderen IMAI-Nutzer verbunden.',
  toastErrorNotMember: 'Du bist kein Mitglied dieses Workspaces mehr.',
  toastErrorProvider:
    'Die Anmeldung wurde nicht abgeschlossen. Versuch es erneut.',
  toastErrorGeneric:
    'Das Konto konnte nicht verbunden werden. Versuch es erneut.',
};
